"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessInformationGroup = void 0;
const AmlCtfSanctionsProgram_1 = require("./businessinformationgroup/AmlCtfSanctionsProgram");
const BusinessKrn_1 = require("./businessinformationgroup/BusinessKrn");
const CompanyNameGroup_1 = require("./businessinformationgroup/CompanyNameGroup");
const EntityType_1 = require("./businessinformationgroup/EntityType");
const License_1 = require("./businessinformationgroup/License");
const Location_1 = require("./businessinformationgroup/Location");
const MaxNumberOfEntities_1 = require("./businessinformationgroup/MaxNumberOfEntities");
const PstEmail_1 = require("./businessinformationgroup/PstEmail");
const RegistrationAuthorityGroup_1 = require("./businessinformationgroup/RegistrationAuthorityGroup");
const RegistrationCountryGroup_1 = require("./businessinformationgroup/RegistrationCountryGroup");
const RegistrationIdGroup_1 = require("./businessinformationgroup/RegistrationIdGroup");
exports.BusinessInformationGroup = {
    aml_ctf_sanctions_program: AmlCtfSanctionsProgram_1.AmlCtfSanctionsProgram,
    business_krn: BusinessKrn_1.BusinessKrn,
    company_name_group: CompanyNameGroup_1.CompanyNameGroup,
    entity_type: EntityType_1.EntityType,
    license: License_1.License,
    location: Location_1.Location,
    max_number_of_entities: MaxNumberOfEntities_1.MaxNumberOfEntities,
    pst_email: PstEmail_1.PstEmail,
    registration_authority_group: RegistrationAuthorityGroup_1.RegistrationAuthorityGroup,
    registration_country_group: RegistrationCountryGroup_1.RegistrationCountryGroup,
    registration_id_group: RegistrationIdGroup_1.RegistrationIdGroup,
};
